/* global report */
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

function addSlugIfMissingRecursive(item) {
  if (!item.slug) {
    item.slug =
      Math.random()
        .toString(36)
        .substring(2, 15) +
      Math.random()
        .toString(36)
        .substring(2, 15);
  }
  if (item.children) {
    item.children.forEach((element) => {
      addSlugIfMissingRecursive(element);
    });
  }
}

function findItemSistersBySlug(items, slug) {
  var founditems = [];

  let ii = findItemParentBySlug(items, slug);
  if (ii && ii.children) {
    founditems = ii.children;
  }
  if (founditems.length == 0) {
    founditems = [...items];
  }
  return founditems;
}

function findItemBySlug(items, slug) {
  var founditem = null;
  items.forEach((element) => {
    if (element.slug === slug) {
      founditem = element;
    }
    if (!founditem && element.children) {
      founditem = findItemBySlug(element.children, slug);
    }
  });
  return founditem;
}

function findItemParentBySlug(items, slug) {
  var founditem = null;
  var parent = null;
  items.forEach((element) => {
    if (element.slug === slug) {
      founditem = element;
    }
    if (!founditem && element.children) {
      founditem = findItemBySlug(element.children, slug);
      if (founditem) {
        parent = element;
      }
    }
  });
  return parent;
}

export default new Vuex.Store({
  state: {
    data: {
      items: [],
      title: "",
    },
    iframeUrl: "",
    iframeWidth: 3000,
    iframeHeight: 3000,
    loggedIn: false,
    loggedTry: false,
  },
  mutations: {
    initSlugs: function(state) {
      var newItems = [...state.data.items];
      newItems.forEach((element) => {
        addSlugIfMissingRecursive(element);
      });
      state.data.items = newItems;
    },
    openBySlug: function(state, payload) {
      var newItems = [...state.data.items];
      let item = findItemBySlug(newItems, payload.slug);
      if (item) {
        if (item.open) {
          item.open = false;
          item.children = [...item.children];
        } else {
          // open

          let sisters = findItemSistersBySlug(newItems, payload.slug);
          sisters.forEach(function(x) {
            x.open = false;
          });
          item.open = true;
          let tempSlug = payload.slug;
          while (findItemParentBySlug(newItems, tempSlug)) {
            let ii = findItemParentBySlug(newItems, tempSlug);
            ii.open = true;
            tempSlug = ii.slug;
          }
        }
      }
      state.data.items = [...newItems];
    },

    activateBySlug: function(state, payload) {
      var item = findItemBySlug(state.data.items, payload.slug);
      document.title =
        window.title +
        (item ? " - " + (item.name || item.title) : "") +
        " - Allied Reporting Dashboard";

      if (item) {
        state.iframeUrl = item.iframe;
        state.iframeWidth = item.width || 1500;
        state.iframeHeight = item.height || 3000;

        let path = window.location.pathname;
        if (path.indexOf(":") > 0) {
          path = path.substring(path.indexOf("://"), path.lastIndexOf("/"));
        } else {
          path = path.substring(path.indexOf("://") + 2);
        }
        history.pushState(
          {
            page: 1,
          },
          "Allied Reporting Dashboard",
          path + "/report:" + payload.slug
        );
        document.title =
          window.title +
          (item ? " - " + (item.name || item.title) : "") +
          " - Allied Reporting Dashboard";
      }
    },
    handleLogin(state, payload) {
      if (payload.response == true) {
        state.data.items = [...payload.items];
        state.data.title = payload.title;
        state.loggedIn = true;
      } else {
        state.loggedIn = false;
        state.loggedTry = true;
      }

      return state;
    },
  },
  actions: {
    initSlugs: function(context) {
      context.commit("initSlugs");
    },
    openBySlug(context, slug) {
      context.commit("openBySlug", {
        slug,
      });
    },
    activateBySlug(context, slug) {
      context.commit("activateBySlug", {
        slug,
      });
    },
    async login(context, data) {
      var path = window.location.pathname;
      if (path.indexOf(":") > 0) {
        path = path.substring(path.indexOf("://"), path.lastIndexOf("/"));
      } else {
        path = path.substring(path.indexOf("://") + 2);
      }
      if (path[0] !== "/") {
        path = "/" + path;
      }
      const response = await axios.post(path, {
        login: data.login,
        password: data.password,
      });
      context.commit("handleLogin", response.data);
      if (context.state.loggedIn) {
        if (window.report) {
          context.commit("activateBySlug", {
            slug: report,
          });
          context.commit("openBySlug", {
            slug: report,
          });
        } else {
          if (context.state.data.items && context.state.data.items.length > 0) {
            let slug = context.state.data.items[0].slug;
            context.commit("activateBySlug", {
              slug: slug,
            });
            context.commit("openBySlug", {
              slug: slug,
            });
          }
        }
      }
    },
  },
  modules: {},
});
